import React, {useState, useEffect} from 'react'
import Loader from '../Loader/Loader'
import { getUsers } from '../../Web Apis/Apis'
import { useNavigate } from 'react-router'
import { message } from 'antd'

function Home() {
const [loading, setLoading] = useState(false)
const [userData, setUserData] = useState([])
  const [totalCount, setTotalCount] = useState(0)
  const [activeCount, setActiveCount] = useState(0)
  const [inactiveCount, setInactiveCount] = useState(0)

  const navigate = useNavigate();


  // Listen for back button and redirect to /home
  useEffect(() => {
    const handlePopState = () => {
      navigate('/home'); // Redirect to /home when the back button is pressed
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate]);



const getAllUsers = async() => {
  setLoading(true)
  try {
    const response = await getUsers()

    let activeCounts = 0
    let inactiveCounts = 0

    if (response?.data?.success){
      setUserData(response?.data?.data)
      setTotalCount(response?.data?.data?.length)

      response?.data?.data?.forEach((user) => {
        if(user?.active){
          activeCounts++;
        } else {
          inactiveCounts++
        }
      })

      setActiveCount(activeCounts)
      setInactiveCount(inactiveCounts)
    }
  } catch (error) {
    console.log("Error in count users", error.message)
   
         if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
           // Handle internet disconnection
           return;
         }
         // Handle specific error cases
         if (error?.response?.status === 401) {
           window.alert("Your account is logged in to another device, please login again !")
           localStorage.clear();
           window.location.href="/login"
         }
         if (error?.response?.status === 500) {
           message.error("Server not responding")
         }

  } finally {
    setLoading(false)
  }
}


useEffect(()=> {
getAllUsers()
},[])



  return (
    <div className="p-4">
    <h2 className="text-3xl font-bold text-red-400">Dashboard</h2>
    <p className='text-blue-400'>Welcome to the Giftr admin dashboard !</p>

    {/* Cards */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 my-4">
      <div 
      onClick={()=> navigate("/user-management")}
      className="bg-gradient-to-r from-purple-400 to-blue-500 text-white shadow-lg rounded-lg p-6 hover:shadow-2xl transition-shadow duration-300 cursor-pointer"
      >
        <h3 className="text-lg font-semibold">Total Users</h3>
        <p className="text-4xl font-bold">{totalCount}</p>
        <p className="mt-2 text-sm">Total number of registered users</p>
      </div>
      <div
       onClick={()=> navigate("/active-users")} 
      className="bg-gradient-to-r from-green-400 to-teal-500 text-white shadow-lg rounded-lg p-6 hover:shadow-2xl transition-shadow duration-300 cursor-pointer"
      >
        <h3 className="text-lg font-semibold">Active users</h3>
        <p className="text-4xl font-bold">{activeCount}</p>
        <p className="mt-2 text-sm">Currently active users</p>
      </div>
      <div 
       onClick={()=> navigate("/in-active-users")}
      className="bg-gradient-to-r from-red-400 to-pink-500 text-white shadow-lg rounded-lg p-6 hover:shadow-2xl transition-shadow duration-300 cursor-pointer"
      >
        <h3 className="text-lg font-semibold">Inactive Users</h3>
        <p className="text-4xl font-bold">{inactiveCount}</p>
        <p className="mt-2 text-sm">Users who are not active</p>
      </div>
    </div>

    {loading && <Loader />}
  </div>
  )
}

export default Home